import { signal } from '@angular/core';
import { Modal } from 'flowbite';

export class ConfirmationModalState {
  readonly modal = signal<Modal | undefined>(undefined);
  readonly showed = signal(false);
  readonly running = signal(false);

  showModal(modalElement: HTMLElement) {
    const modal = new Modal(modalElement, {
      placement: 'center',
      closable: false,
      onHide: () => this.showed.set(false),
      onShow: () => this.showed.set(true),
    });
    this.modal.set(modal);
    modal.toggle();
  }

  async run(action: () => Promise<void>) {
    if (this.running()) return;
    this.running.set(true);
    try {
      await action();
      this.modal()?.hide();
    } finally {
      this.running.set(false);
    }
  }
}
